import React, { useEffect, useState } from "react";
import { Route, RouteProps, useNavigate } from "react-router-dom";
import { getAuth } from "../services/AuthService";
import Footer from "./Footer";
import { Header } from "./Header/Header";
import Advertising from "../common/Advertising";
import getStaticRoutes, { hasComponent, resolveComponent } from "./Routes";
import { menuItem, MenuResponseJSON } from "../helpers/interfaces";
import { useMenuSingleton } from '../singleton/menuSingleton';
import ScrollToTopButton from "./ScrollToTopButton";

export type RouteItem = RouteProps & {
    id: string,
    name: string,
    path: string,
    component: (props: any) => JSX.Element,
    private?: boolean,
    hiddenHeaderAdv?: boolean,
    hiddenFooterAdv?: boolean,
};

type AppRouteProps = {
    id: string,
    isPrivate?: boolean,
    element?: React.ReactNode,
    hiddenHeaderAdv?: boolean,
    hiddenFooterAdv?: boolean,
    menu: MenuResponseJSON
};

export const fetchMenuData = async (data: MenuResponseJSON) => {
    try {
        const generateRoutes = async (
            menuItems: menuItem[]
        ): Promise<RouteItem[]> => {
            let routes: RouteItem[] = [{
                id: "home",
                path: "/",
                component: resolveComponent('home'),
                name: "Home",
                hiddenHeaderAdv: true
            }];

            const traverseMenu = async(items: menuItem[], type: string | null) => {
                items.forEach((item: menuItem) => {
                    if (item.url) {
                        const hasItemTypeComponent = hasComponent(item.type);
        
                        routes.push({
                            id: item.type,
                            /** TODO: Modifica richiesta da Ismail per forzare articoli per meet con cliente */
                            /** Da risolvere il primo possibile */
                            path: (type === 'articoli' ? 'articoli/' : '') + item.url,
                            component: hasItemTypeComponent
                                ? resolveComponent(item.type, item)
                                : resolveComponent(type !== null ? type : item.type, item),
                            name: item.label,
                        });
                    }

                    if (item.sub && item.sub.length > 0) {
                        const itemSub = item.sub.map((subItem) => {
                            subItem = subItem.url ? {
                            ...subItem,
                            url: subItem.url.split('#')[0]
                            } : subItem;

                            return subItem
                        })
                        traverseMenu(
                            itemSub,
                            item.type !== 'main' ? (
                                type ? type : item.type
                            ) : null
                        );
                    }
                });
            };

            await traverseMenu(menuItems, null);
            const staticRoutes = await getStaticRoutes();
            routes = routes.concat(staticRoutes);

            return routes;
        };

        const generatedRoutes = await generateRoutes(data.data);

        return generatedRoutes;
    } catch (error) {
        console.error("Errore durante il fetch del menu:", error);
        return [];
    }
};

/** TODO: Modifica richiesta da Ismail per forzare articoli per meet con cliente */
/** Da risolvere il primo possibile */
export function createRoutes(routes: RouteItem[], menu: MenuResponseJSON) {
    return routes.map((route: RouteItem, index: number) => {
        return <Route
            id={index + '_' + route.id}
            key={index}
            path={route.path}
            element={<PrivateRoute
                id={route.id}
                element={<route.component />}
                isPrivate={route.private || false}
                hiddenHeaderAdv={route.hiddenHeaderAdv || false}
                hiddenFooterAdv={route.hiddenFooterAdv || false}
                menu={menu}
            />}
        />
    })
}

export function PrivateRoute(
    props: AppRouteProps
) {
    const { isPrivate, element, hiddenHeaderAdv = false, hiddenFooterAdv = false } = props;
    const navigate = useNavigate();
    const [showPage, setShowPage] = useState<boolean>(false);
    const { updateMenu } = useMenuSingleton();

    useEffect(() => {
        updateMenu(props.menu);

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });

        const auth = getAuth();

        if (isPrivate && !auth) {
            navigate(`/accedi?alert=1&redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`);
        } else {
            setShowPage(true);
        }
    }, [isPrivate,  props.menu, navigate, setShowPage, updateMenu])

    return showPage ? <>
        <Header menu={props.menu} />
        <div id={`page-${props.id}`} className="page m-auto container">
            {!hiddenHeaderAdv
                ? <Advertising code="banner-top" as="div" />
                : <></>
            }
            {element}
            {!hiddenFooterAdv ? <>
                <hr />
                <Advertising code="banner-footer" as="div" />
            </> : <></>}
            <Footer menu={props.menu} />
            <ScrollToTopButton />
        </div>
    </> : <></>
}
